@let location =
  user.homeLocation
    ? (user.homeLocation | locationName)
    : user.organizationalUnit.locationId
      ? (user.organizationalUnit.locationId
        | locationIdToLocation
        | async
        | locationName)
      : ('general.n/a' | translate);
@defer (on hover) {
  <div nz-tooltip [nzTooltipTitle]="tooltip" class="kpi-parent-container">
    <ng-container *ngTemplateOutlet="homeLocationValue"></ng-container>
  </div>
} @placeholder {
  <div class="kpi-parent-container">
    <ng-container *ngTemplateOutlet="homeLocationValue"></ng-container>
  </div>
}

<ng-template #homeLocationValue>
  <span class="kpi-title text-truncate">
    {{ 'shift_timeline.kpi_setting.home_location' | translate }}
  </span>
  <div class="kpi-value">
    <span class="kpi-text text-truncate">
      {{ location }}
    </span>
  </div>
</ng-template>

<ng-template #tooltip>
  <span class="fw-normal">
    {{ 'shift_timeline.kpi_setting.home_location' | translate }}
  </span>
  <span class="d-block"> {{ location }} </span>
</ng-template>
